import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableCell, TableRow } from '@/core/ui';
import { Typography } from '@mui/material';
// const TableHeadRow = ({ columns, typographyVariant, noTopBorder, lineHeight, cellPositionRelative }: Props) => {
const TableHeadRow = (props) => {
    return (_jsx(TableRow, { children: _jsx(TableHeadCells, { ...props }) }));
};
// TODO: to delete all comments later if no need.
const TableHeadCells = ({ headColumns, typographyVariant, noTopBorder, lineHeight, noWrap: ownerNoWrap }) => {
    // return columns.map(({ text, align, noWrap, span, width, maxWidth }, index) => (
    return headColumns.map((headColumn, index) => {
        const { value, align, noWrap, span, width, minWidth, maxWidth } = headColumn;
        return (
        // <TableCell key={index} colSpan={span} width={width} sx={{ maxWidth: maxWidth, borderTop: noTopBorder ? 0 : undefined }}>
        _jsx(TableCell, { colSpan: span, width: width, align: align, 
            // TODO: refactor later
            // sx={{ borderTop: noTopBorder ? 0 : undefined, position: cellPositionRelative ? 'relative' : undefined, minWidth }}
            sx: { borderTop: noTopBorder ? 0 : undefined, minWidth, maxWidth }, children: value && (_jsx(_Fragment, { children: typeof value === 'string' ? (_jsx(Typography, { component: "span", variant: typographyVariant || 'body2', 
                    // TODO: align adds `text-align:` prop for span but it is not working. commented. TODO: to delete if tested well.
                    // align={align}
                    noWrap: noWrap ?? ownerNoWrap, sx: {
                        fontSize: 'inherit',
                        fontWeight: (theme) => theme.typography.fontWeightMedium,
                        lineHeight: lineHeight,
                    }, children: value })) : (value(headColumn)) })) }, index));
    });
};
export { TableHeadCells, TableHeadRow };
